import qs from 'qs';

import store from 'root/apps/pages/store';

import { getOptions, OPTIONS } from '../utils/options';
import { getChannelName, getHubSmartState } from '../utils/storage';
import { SocketConnectionManager } from './socketConnectionManager';
import { isStatusConnected, PRINTER_KINDS, PRINTER_STATUSES } from './types';

export class SocketClient extends SocketConnectionManager {
  // Don't touch this, it's used by the golf extension
  public readonly PRINTER_KINDS = PRINTER_KINDS;

  constructor() {
    super();
  }

  public getCFDParams = () => {
    return qs.stringify(
      {
        channelName: getChannelName(),
        accountId: window.merchantos.session.getSystemCustomerID(),
        locale: getOptions()[OPTIONS.LOCALE],
      },
      { addQueryPrefix: true }
    );
  };

  public getHubPrinterStatus(kind: PRINTER_KINDS): PRINTER_STATUSES | undefined {
    const { connection, defaultPrinters } = store.getState().hub;

    return (getHubSmartState()?.defaultPrinters[kind]?.status ||
      (isStatusConnected(connection.hub) && defaultPrinters?.[kind]?.status)) as PRINTER_STATUSES;
  }
}

const socketClient = new SocketClient();

export { socketClient };

// Don't touch this, it's used by the golf extension
window.socketClient = socketClient;
